import { Mail, Phone, Calendar, User, MapPin } from 'lucide-react';
import Select from 'react-select';

const locationOptions = [
    { value: 'No Constraint', label: 'No Constraint' },
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Hosur', label: 'Hosur' },
    { value: 'Trichy', label: 'Trichy' },
    { value: 'Madurai', label: 'Madurai' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Gurgaon', label: 'Gurgaon' },
    { value: 'Noida', label: 'Noida' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Ahmedabad', label: 'Ahmedabad' },
    { value: 'Trivandrum', label: 'Trivandrum' },
    { value: 'Coimbatore', label: 'Coimbatore' },
    { value: 'Mohali', label: 'Mohali' },
    { value: 'Indore', label: 'Indore' },
    { value: 'Jaipur', label: 'Jaipur' },
    { value: 'Nagpur', label: 'Nagpur' },
];

const PersonalInfoSection = ({ studentData, editableData, isEditing, onInputChange }) => {
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const editableFields = [
        'name', 'email_Id', 'contactNo', 'ParentNo', 'address',
        'educationLevel', 'department', 'clg_name', 'educationCourse',
        'dob', 'studentRequirement', 'desiredlocation', 'gender'
    ];

    return (
        <div className="info-grid">

            {/* Full Name */}
            <div className="info-item">
                <label>Full Name </label>
                {isEditing && editableFields.includes('name') ? (
                    <input
                        type="text"
                        value={editableData.name || ''}
                        onChange={(e) => onInputChange('name', e.target.value)}
                    />
                ) : (
                    <span>{studentData.name}</span>
                )}
            </div>

            {/* Email */}
            <div className="info-item">
                <label>Email</label>
                {isEditing && editableFields.includes('email_Id') ? (
                    <input
                        type="email"
                        value={editableData.email_Id || ''}
                        onChange={(e) => onInputChange('email_Id', e.target.value)}
                    />
                ) : (
                    <span><Mail size={16} /> {studentData.email_Id}</span>
                )}
            </div>

            {/* Contact Number */}
            <div className="info-item">
                <label>Contact Number</label>
                {isEditing && editableFields.includes('contactNo') ? (
                    <input
                        type="tel"
                        value={editableData.contactNo || ''}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            onInputChange('contactNo', value.slice(0, 10));
                        }}
                        maxLength={10}
                    />
                ) : (
                    <span><Phone size={16} /> {studentData.contactNo}</span>
                )}
            </div>

            {/* Parent's Number */}
            <div className="info-item">
                <label>Parent's Number</label>
                {isEditing && editableFields.includes('ParentNo') ? (
                    <input
                        type="tel"
                        value={editableData.ParentNo || ''}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            onInputChange('ParentNo', value.slice(0, 10));
                        }}
                        maxLength={10}
                    />
                ) : (
                    <span><Phone size={16} /> {studentData.ParentNo}</span>
                )}
            </div>

            {/* Date of Birth */}
            <div className="info-item">
                <label>Date of Birth</label>
                {isEditing && editableFields.includes('dob') ? (
                    <input
                        type="date"
                        value={editableData.dob || ''}
                        onChange={(e) => onInputChange('dob', e.target.value)}
                        max={new Date().toISOString().split('T')[0]}
                    />
                ) : (
                    <span><Calendar size={16} /> {formatDate(studentData.dob)}</span>
                )}
            </div>

            {/* Gender */}
            <div className="info-item">
                <label>Gender</label>
                {isEditing && editableFields.includes('gender') ? (
                    <select
                        value={editableData.gender ?? studentData.gender ?? ''}
                        onChange={(e) => onInputChange('gender', e.target.value)}
                    >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                ) : (
                    <span><User size={16} /> {studentData.courseDetails.gender || ''}</span>
                )}
            </div>

            {/* Desired Company Location */}
            <div className="info-item">
                <label>Preferred Job Location</label>
                {isEditing && editableFields.includes('desiredlocation') ? (
                    <Select
                        isMulti
                        name="desiredlocation"
                        options={locationOptions}
                        value={(() => {
                            const currentValues = Array.isArray(editableData?.desiredlocation)
                                ? editableData.desiredlocation
                                : [editableData?.desiredlocation].filter(Boolean);
                            return locationOptions.filter(option =>
                                currentValues.includes(option.value)
                            );
                        })()}
                        onChange={(selected) => {
                            const values = selected ? selected.map(option => option.value) : [];
                            onInputChange('desiredlocation', values);
                        }}
                        className="react-select-container"
                        classNamePrefix="react-select"
                    />
                ) : (
                    <span>
                        <MapPin size={16} />
                        {Array.isArray(studentData?.desiredlocation)
                            ? studentData.desiredlocation.map(location =>
                                locationOptions.find(opt => opt.value === location)?.label || location
                            ).join(', ')
                            : (studentData?.desiredlocation
                                ? (locationOptions.find(opt => opt.value === studentData.desiredlocation)?.label || studentData.desiredlocation)
                                : '')}
                    </span>
                )}
            </div>

            {/* Address */}
            <div className="info-item full-width">
                <label>Address</label>
                {isEditing && editableFields.includes('address') ? (
                    <textarea
                        value={editableData.address || ''}
                        onChange={(e) => onInputChange('address', e.target.value)}
                        rows="3"
                    />
                ) : (
                    <span><MapPin size={16} /> {studentData.address}</span>
                )}
            </div>
        </div>
    );
};

export default PersonalInfoSection;